import moment from 'moment-timezone';

/** Compare period boundaries — filters and API may use different string formats. */
export const sameCalendarDay = (a, b) => {
  if (a == null || b == null) return false;
  const ma = moment(a);
  const mb = moment(b);
  return ma.isValid() && mb.isValid() && ma.format('YYYY-MM-DD') === mb.format('YYYY-MM-DD');
};

/** True when the selected range is the group's `present` period (matches "(current)" in the period dropdown). */
export const selectionMatchesPresentPeriod = (startDate, endDate, groupPeriods) => {
  const present = groupPeriods?.find(p => p.period === 'present');
  if (!present?.start || !present?.end) return false;
  return sameCalendarDay(present.start, startDate) && sameCalendarDay(present.end, endDate);
};

export const getDaysUntil = dateISO => {
  if (!dateISO) return null;
  return moment(dateISO).startOf('day').diff(moment().startOf('day'), 'days');
};

/** Stage 2 / 3 — teal for >3d, amber 1–3, red 0/overdue (manager exempt from "far out grey"). */
export const getActiveUrgency = dateISO => {
  const daysUntil = getDaysUntil(dateISO);
  if (daysUntil === null)
    return {
      key: 'future',
      daysUntil: null,
      card: 'sFuture',
      pill: 'pillFuture',
      fill: 'fillGrey',
    };
  if (daysUntil < 0)
    return { key: 'urgent', daysUntil, card: 'sUrgent', pill: 'pillUrgent', fill: 'fillRed' };
  if (daysUntil === 0)
    return { key: 'urgent', daysUntil, card: 'sUrgent', pill: 'pillUrgent', fill: 'fillRed' };
  if (daysUntil <= 3)
    return { key: 'warning', daysUntil, card: 'sWarning', pill: 'pillWarning', fill: 'fillAmber' };
  return { key: 'safe', daysUntil, card: 'sSafe', pill: 'pillSafe', fill: 'fillTeal' };
};

/** Builds the urgency pill text for stages 1 & 2 (red/amber/teal urgency keys). */
export const urgencyPillText = (urgency, days) => {
  if (urgency.key === 'future' || days === null) return '🕐\u00A0—';
  const prefix =
    urgency.key === 'urgent' ? '🔴\u00A0' : urgency.key === 'warning' ? '⚠️\u00A0' : '🟢\u00A0';
  let label;
  if (urgency.key === 'urgent' && days === 0) label = 'Due Today';
  else if (urgency.key === 'urgent') label = `${Math.abs(days)} Days Overdue`;
  else if (urgency.key === 'warning') label = `${days} Days Left`;
  else label = `${days} Days Away`;
  return `${prefix}${label}`;
};
